import { render, staticRenderFns } from "./appointmentChart.vue?vue&type=template&id=764046f4&scoped=true"
import script from "./appointmentChart.vue?vue&type=script&lang=js"
export * from "./appointmentChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764046f4",
  null
  
)

export default component.exports